module.exports = __webpack_public_path__ + "94fc085ff8f3f1808813f4608d667c5c.svg";